var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 72,
    viewBox: "0 0 108 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_504_2)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.9599 22.8002C6.8399 31.1402 12.4799 33.5402 10.6799 46.7402C9.2399 57.2402 16.2599 61.5002 20.5199 62.6402C22.5599 63.1802 30.4799 63.0002 30.3599 57.3002C29.9999 37.8602 49.9199 21.4202 31.6199 12.7802C24.1799 9.18017 7.1399 3.90017 6.9599 22.8002Z",
    fill: "#B198F8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_504_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.5401 15.8398H30.0001C27.5811 15.8398 25.6201 17.8008 25.6201 20.2198V51.8398C25.6201 54.2589 27.5811 56.2198 30.0001 56.2198H87.5401C89.9591 56.2198 91.9201 54.2589 91.9201 51.8398V20.2198C91.9201 17.8008 89.9591 15.8398 87.5401 15.8398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5401 15.8398H30.0001C27.5811 15.8398 25.6201 17.8008 25.6201 20.2198V51.8398C25.6201 54.2589 27.5811 56.2198 30.0001 56.2198H87.5401C89.9591 56.2198 91.9201 54.2589 91.9201 51.8398V20.2198C91.9201 17.8008 89.9591 15.8398 87.5401 15.8398Z",
    stroke: "#32CDFB",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 29,
    width: 35,
    height: 5,
    rx: 2.5,
    fill: "#32CDFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 38,
    width: 20,
    height: 5,
    rx: 2.5,
    fill: "#32CDFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_504_2",
    x: 9.62012,
    y: -0.160156,
    width: 98.2998,
    height: 72.3799,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0666667 0 0 0 0 0.309804 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_504_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_504_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_504_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 72,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.e408896e203d0098266bb7c556b0b2ee.svg";
export { ForwardRef as ReactComponent };